import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import defaultStyles from './AttributesVirtualizedTable.module.css';
import jlrStyles from './AttributesVirtualizedTableJlr.module.css';
import { VirtualizedTable, AttributesSelector } from '..';
import { optionalColumnsWithShift } from '../../staticData';
import { getSelectedOptionalColumns } from '../../utils/tableUtils';
import { usePlantAndLinesStore } from '../../providers/PlantAndLinesStore/PlantAndLinesStore';
import { setStylesAccordingToPlant } from '../../utils/utils';

const AttributesVirtualizedTable = ({
  rowsData,
  fixedColumns,
  headerRowHeight = 40,
  rowHeight = 40,
  fixedColumnsStyles = {
    headerStyles: {
      color: '#0275A7',
      fontSize: '13px',
      fontWeight: '600',
      boxSizing: 'border-box',
    },
  },
  optionalColumnsStyles = {
    headerStyles: {
      color: '#707070',
      backgroundColor: 'white',
      zIndex: 1,
      boxSizing: 'border-box',
    },
  },
  listHeight = 400,
  conditionalRowClassName,
  ...props
}) => {
  const [plant] = usePlantAndLinesStore().plantState;
  const [styles, setStyles] = useState(defaultStyles);
  const [selectedOptionalColNames, setSelectedOptionalColNames] = useState([]);

  const fixedColumnsStyled = fixedColumns.map(column => ({
    ...column,
    ...fixedColumnsStyles,
  }));
  const selectedOptionalColumns = getSelectedOptionalColumns(
    optionalColumnsWithShift,
    selectedOptionalColNames,
    optionalColumnsStyles,
  );

  const attributesTableColumns = [
    ...fixedColumnsStyled,
    ...selectedOptionalColumns,
  ];

  useEffect(() => {
    setStylesAccordingToPlant(plant, setStyles, defaultStyles, jlrStyles);
  }, [plant]);

  return (
    <>
      <div className={styles.ToolBar}>
        <AttributesSelector
          className={styles.Attribute}
          columns={optionalColumnsWithShift}
          selectedOptionalCols={selectedOptionalColNames}
          applyColumnsSelection={selection =>
            setSelectedOptionalColNames(selection)
          }
        />
      </div>
      <div style={{ height: listHeight }}>
        <VirtualizedTable
          columns={attributesTableColumns}
          rows={rowsData.filteredData || rowsData.data}
          listHeight={listHeight}
          rowHeight={({ index }) => (index === 0 ? headerRowHeight : rowHeight)}
          fixedColumnCount={fixedColumns.length}
          classNames={{
            tableContainerClassName: styles.attributesTable,
            tableClassName: styles.table,
            tableHeadClassName: styles.tableHead,
            tableCellClassName: styles.mTablecell,
            tableRowClassName: conditionalRowClassName,
          }}
          classNameBottomLeftGrid={
            fixedColumns.length === attributesTableColumns.length
              ? styles.BottomLftWithScrollBar
              : styles.BottomLftWithoutScrollBar
          }
          classNameBottomRightGrid={styles.BottomRgt}
          classNameTopLeftGrid={styles.TopLft}
          classNameTopRightGrid={styles.TopRgt}
          {...props}
        />
      </div>
    </>
  );
};

AttributesVirtualizedTable.prototypes = {
  rowsData: PropTypes.shape({
    data: PropTypes.array,
    filteredData: PropTypes.array,
    isLoading: PropTypes.bool,
  }).isRequired,
  fixedColumns: PropTypes.arrayOf(
    PropTypes.shape({
      width: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      field: PropTypes.string.isRequired,
    }),
  ).isRequired,
  rowHeight: PropTypes.number,
  headerRowHeight: PropTypes.number,
  fixedColumnsStyles: PropTypes.shape({
    headerStyles: PropTypes.object,
    cellStyles: PropTypes.object,
    styles: PropTypes.object,
  }),
  optionalColumnsStyles: PropTypes.shape({
    headerStyles: PropTypes.object,
    cellStyles: PropTypes.object,
    styles: PropTypes.object,
  }),
  listHeight: PropTypes.number,
  conditionalRowClassName: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
  ]),
};

export default AttributesVirtualizedTable;
